/**
 * Credits Domain - DI 容器配置
 */

import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CreditsApi, CreditsApiImpl } from './apis/credits-api';
import { CreditsService } from './services/credits-service';
import { CreditsServiceImpl } from './services/credits-service-impl';
import { SettlementService, SettlementServiceImpl } from './services/settlement-service';

export const creditsContainer = new ContainerModule((bind) => {
    bind<CreditsApi>(CreditsApi).to(CreditsApiImpl).inSingletonScope();
    bind<CreditsService>(CreditsService).to(CreditsServiceImpl).inSingletonScope();
    bind<SettlementService>(SettlementService).to(SettlementServiceImpl).inSingletonScope();
});

export * from './types';
export * from './services/credits-service';
export * from './services/settlement-service';
export * from './apis/credits-api';
